module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('information-popup', {
    attrs: {
      "modal-id": "inscriptionGuidelinesPopup"
    }
  }, [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Inscription Guidelines")]), _vm._v(" "), _vm._t("default", [_c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n            16 characters allowed per line. Characters include all letters, numbers, punctuation marks,\n            and blank spaces found on a standard English keyboard.\n            Inscriptions will be automatically centered and engraved in UPPERCASE letters.\n            Inscriptions that contain websites, phone numbers, twitter handles, and/or manifestos are not permitted.\n            Discriminatory, political, offensive, or inappropriate messages as determined by Indian Creek Plaza will be declined.\n        ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76440322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/InscriptionGuidelines.vue
// module id = Ed6v
// module chunks = 1